import { render } from "./HistoricoObjetoButton.vue?vue&type=template&id=ea3c3714&scoped=true"
import script from "./HistoricoObjetoButton.vue?vue&type=script&lang=js"
export * from "./HistoricoObjetoButton.vue?vue&type=script&lang=js"

import "./HistoricoObjetoButton.vue?vue&type=style&index=0&id=ea3c3714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea3c3714"]])

export default __exports__